"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectableButton = void 0;

var _1 = require(".");

var Button_1 = require("../ant/Button");

var theme_1 = require("../theme");

exports.SelectableButton = (0, _1.styled)(Button_1.Button)(_templateObject(), function (props) {
  return props.selected ? "background: ".concat((0, theme_1.getColor)(props.theme, '@gray-2'), " !important;") : '';
}, function (props) {
  return props.selected ? "color: ".concat((0, theme_1.getColor)(props.theme, '@gray-7'), " !important;") : '';
});